module.exports = __webpack_public_path__ + "media/images/emotions/sebastiao-fear-3c46403a06e3009a5614e67fa27b043c.svg";